/** Whole-percent label for the settled resolved table (Figma shows `27%`). */
export function formatResolvedPct(value: number | null): string {
  return `${String(Math.round(value ?? 0))}%`;
}
